module.exports = __webpack_public_path__ + "static/media/asdf.e1e6f63e.PNG";